// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-hva-er-en-garantiforsikring-js": () => import("./../../../src/pages/hva-er-en-garantiforsikring.js" /* webpackChunkName: "component---src-pages-hva-er-en-garantiforsikring-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-tilbud-garantiforsikring-js": () => import("./../../../src/pages/tilbud-garantiforsikring.js" /* webpackChunkName: "component---src-pages-tilbud-garantiforsikring-js" */),
  "component---src-templates-product-js": () => import("./../../../src/templates/product.js" /* webpackChunkName: "component---src-templates-product-js" */),
  "component---src-templates-provider-js": () => import("./../../../src/templates/provider.js" /* webpackChunkName: "component---src-templates-provider-js" */)
}

